const datascience = [
    {
        key: 1,
        proj_title: "Bellabeat Wellness Case Study",
        proj_description: "Bellabeat is a high-tech manufacturer of health-focused smart products for women that keeps them informed of their health and activities inspiring and motivating them to take necessary steps in maintaining their health. The aim of this report is to analyse non-Bellabeat devices` smart device usage data to gain insights on some smart device trends, how these trends can be applied to Bellabeat customers and how these trends could be incorporated in any one Bellabeat product`s marketing strategy.",
        link: "https://github.com/leahsaurus/Bellabeat-Analysis"
    },
    {
        key: 2,
        proj_title: "Coal & Lignite Production VS Consumption",
        proj_description: "This project aims to investigate the Coal and Lignite production vs consumption trends in major countries and associations using EDA and Data visualizations and also aims to apply Univariate time series forecasting to predict future trends of the production and consumption of the major regions/continents.",
        link: "https://github.com/leahsaurus/Coal-and-Lignite-Production-vs-Consumption-Analysis"
    },
    {
        key: 3,
        proj_title: "Ear Biometry using DCNN",
        proj_description: "This projects aims to use 4 Deep Learning models for Biometry Identification using ear images of individuals. Two different datasets have been used in this project and the results show a high precision of 95.47% in determining individuals using their ear image samples.",
        link: "https://github.com/leahsaurus/Ear-Biometry-using-DCNN"
    },
    {
        key: 4,
        proj_title: "IT Salary Survey 2020",
        proj_description: "This projects aims to use 4 Deep Learning models for Biometry Identification using ear images of individuals. Two different datasets have been used in this project and the results show a high precision of 95.47% in determining individuals using their ear image samples.",
        link: "https://github.com/leahsaurus/IT-Salary-Europe-2020"
    }
];

export default datascience;